// extracted by mini-css-extract-plugin
export default {"signup_wrap":"signupform_signup_wrap__1YnQx","main_div":"signupform_main_div__gJDfb","text_box":"signupform_text_box__qoHtu"};